export const projectTableOption = {
    menu:false,
    addBtn:false,
    columnBtn:false,
    refreshBtn:false,
    searchBtn:false,
    header:false,
    "column": [
      {
        label: '项目名称',
        prop: 'projectName'
      },
      {
        label: '发布人',
        prop: 'userName',
				width:100
      },
      {
        label: '发布时间',
        prop: 'createTime',
        type:'date',
        format :"yyyy-MM-dd",
				width:100
      },
      {
        label: '开工时间',
        prop: 'startTime',
        type:'date',
        format :"yyyy-MM-dd HH:mm",
				width:135
      }
    ]
  }
  export const feedBackTableOption = {
    menu:false,
    addBtn:false,
    columnBtn:false,
    refreshBtn:false,
    searchBtn:false,
    header:false,
    "column": [
      {
        label: '项目名称',
        prop: 'project_name'
      },
      {
        label: '项目状态',
        prop: 'state',
        formatter:formatState,
        width:80
      },
      {
        label: '反馈人',
        prop: 'name',
        width:120
      },
      {
        label: '反馈时间',
        prop: 'create_time',
        type:'date',
        format :"yyyy-MM-dd",
        width:130
      },
      {
        label: '解决状态',
        prop: 'flag',
        formatter:flagState,
        width:80
      },
    ]
  }

function formatState(row,value,label,column){
  let state;
  if (value === -2){
    state = '用户取消'
  }else if (value === -1){
    state = '未发布'
  }else if (value === 0){
    state = '正在招募'
  }else if (value === 1){
    state = '等待执行'
  }else if (value === 2){
    state = '用户取消'
  }else if (value === 3){
    state = '项目超时'
  }else if (value === 4){
    state = '正在执行'
  }else if (value === 5){
    state = '申请结项'
  }else if (value === 6){
    state = '拒绝结项'
  }else if (value === 7){
    state = '项目完结'
  }
  return state;
}
function flagState(row,value,label,column){
  let flag;
  if (value === 0){
    flag = '未解决'
  }else if (value === 1){
    flag = '已解决'
  }
  return flag;
}
  export const responseTimeTableOption = {
    menu:false,
    addBtn:false,
    columnBtn:false,
    refreshBtn:false,
    searchBtn:false,
    header:false,
    "column": [
      {
        label: '项目名称',
        prop: 'project_name',
        width:350
      },
      {
        label: '发布人',
        prop: 'sname',
        width:100
      },
      {
        label: '发布时间',
        prop: 'create_time',
        type:'date',
        format :"yyyy-MM-dd",
        width:100
      },
      {
        label: '开工时间',
        prop: 'start_time',
        type:'date',
        format :"yyyy-MM-dd HH:mm",
        width:135
      },
      {
        label: '招募完成时间',
        prop: 'end_time',
        type:'date',
        format :"yyyy-MM-dd HH:mm",
        width:135
      },
      {
        label: '项目状态',
        prop: 'state',
        formatter:formatState,
        width:80
      },
      {
        label: '人员需求',
        prop: 'work_types',
        width:280
      },
    ]
  }
  export const positionTableOption = {
    menu:false,
    addBtn:false,
    columnBtn:false,
    refreshBtn:false,
    searchBtn:false,
    header:false,
    "column": [
      {
        label: '省份',
        prop: 'province'
      },
      {
        label: '正在执行项目数',
        prop: 'execProjectCount',
      },
      {
        label: '已完结项目数',
        prop: 'endProjectCount',
      },
      {
        label: '师傅总数',
        prop: 'workerCount'
      },
    ]
  }
